import React, { Fragment } from "react";
import { utils } from "../common/utils";
import { Breakpoint } from 'react-socks';
import { useTranslation } from 'react-i18next';
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";
import CurrencyFormat from './CurrencyFormat';
import { AmountType } from "../common/enums";

export default function (props) {
    const { t } = useTranslation();
    const { discountCodeDetails, settings } = props;


    return (
        
                    <div className="accordion padding-top-1x" role="tablist">
                        
                        
                            <div className="card" key={discountCodeDetails.id}>
                                {/* <div className="card-header" role="tab">
                                    <h6>
                                        <a
                                            href={`#collapse${discountCodeDetails.discountCode}`}
                                            data-toggle="collapse"
                                            data-parent="#accordion2">
                                            <span className={`badge badge-pill `}></span> #{discountCodeDetails.discountCode}
                                            
                                        </a>
                                    </h6>
                                </div> */}
                                <div className="collapse show" id={`#collapse${discountCodeDetails.id}`} role="tabpanel">
                                    <div className="card-body form-group">
                                        <div className="text-bold text-lg form-group row align-items-center">
                                            <span className="col-4 col-form-label text-right">{t("Discount Code")}:&nbsp;</span>
                                            <span className="text-medium col-8">{discountCodeDetails.discountCode}</span>
                                        </div>
                                        <div className="text-bold text-lg form-group row align-items-center">
                                            <span className="col-4 col-form-label text-right">{t("Discount")}:&nbsp;</span>
                                            <span className="text-medium col-8">
                                                {discountCodeDetails.discountCodeAmountType === AmountType.FixedAmount && <CurrencyFormat value={discountCodeDetails.discountValue} settings={settings} />}
                                                {discountCodeDetails.discountCodeAmountType === AmountType.Percentage && <>{discountCodeDetails.discountValue}%</>}
                                            </span>
                                        </div>
                                        <div className="text-bold text-lg form-group row align-items-center">
                                            <span className="col-4 col-form-label text-right">{t("Max Usage")}:&nbsp;</span>
                                            <span className="text-medium col-8">{discountCodeDetails.limitNumberToBeUsedInTotal}</span>
                                        </div>
                                        <div className="text-bold text-lg form-group row align-items-center">
                                            <span className="col-4 col-form-label text-right">{t("Start Date")}:&nbsp;</span>
                                            <span className="text-medium col-8">{utils.dates.getDateTime24String(discountCodeDetails.discountCodeStartDate)}</span>
                                        </div>
                                        <div className="text-bold text-lg form-group row align-items-center">
                                            <span className="col-4 col-form-label text-right">{t("End Date")}:&nbsp;</span>
                                            <span className="text-medium col-8">{utils.dates.getDateTime24String(discountCodeDetails.discountCodeEndDate)}</span>
                                        </div>
                                        
                                        
                                        {/* <div className="padding-bottom-1x">
                                            <button className="btn btn-info" >{t("More Details")}</button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        
                    </div>
                
    );

}
